import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sitekey: String,
    theme: { type: String, default: "light" },
    size: { type: String, default: "normal" }
  }
  static targets = ["widget"]

  connect() {
    this.waitForTurnstile().then(() => {
      if (this.widgetTarget) {
        window.turnstile.render(this.widgetTarget, {
          sitekey: this.sitekeyValue,
          theme: this.themeValue,
          size: this.sizeValue
        })
      }
    }).catch(() => {
      this.#setUnavailableField()
    })
  }

  waitForTurnstile() {
    return new Promise((resolve, reject) => {
      if (window.turnstile) {
        resolve()
        return
      }

      const interval = setInterval(() => {
        if (window.turnstile) {
          clearInterval(interval)
          resolve()
        }
      }, 50)

      setTimeout(() => {
        clearInterval(interval)
        console.error("Timed out waiting for Turnstile script")
        reject(new Error("Turnstile script not loaded"))
      }, 5000)
    })
  }

  #setUnavailableField() {
    const form = this.element.closest("form")
    if (!form) return

    // Avoid duplicates
    if (form.querySelector('input[name="cf-turnstile-unavailable"]')) return

    const hidden = document.createElement("input")
    hidden.type = "hidden"
    hidden.name = "cf-turnstile-unavailable"
    hidden.value = "1"
    form.appendChild(hidden)
  }
}
